import { LockClosedIcon, LockOpenIcon } from '@heroicons/react/24/solid';
import { useGseaEntitlement } from './useGseaEntitlement';
import styles from './FeatureBilling.module.css';

export default function PaidToolBadge() {
  const { hasGseaAccess } = useGseaEntitlement();

  if (hasGseaAccess) {
    return (
      <span
        className={`${styles.paidBadge} ${styles.paidBadgeUnlocked}`}
        aria-label="GSEA unlocked"
        title="GSEA unlocked"
      >
        <LockOpenIcon aria-hidden />
      </span>
    );
  }

  return (
    <span className={styles.paidBadge} aria-label="Paid tool" title="Paid tool">
      <LockClosedIcon aria-hidden />
    </span>
  );
}
